// extracted by mini-css-extract-plugin
export default {"bannerContainer":"About_bannerContainer__gKKgw","collapsesContainer":"About_collapsesContainer__MRyJY"};